module.exports = __webpack_public_path__ + "img/charm_tick.32fc72b1.svg";